<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs" classes="modal fade show" content-class="modal-dialog" :click-to-close="false">
		<form class="modal-content" role="form" @submit.prevent="onAdd(close)">
			<div class="modal-header py-2">
				<h1 class="modal-title fs-5">{{$t('header.students-group-add')}}</h1>
				<button type="button" class="btn-close" @click="$emit('cancel', close)" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div class="text-center" v-if="loading">
					<loading-spinner
						:overlay="loading"
						:text="$t('text.loading-data')"
					></loading-spinner>
				</div>
				<div v-else>
					<div class="mb-3">
						<label for="select-lang" class="form-label">{{$t('text.lang')}}:</label>
						<select id="select-lang" class="form-select" v-model="lang" required>
							<option :value="lang.key" v-for="lang in appModel.examLangs" :key="lang.key">{{lang.name}}</option>
						</select>
					</div>
					<div class="mb-3">
						<label for="select-speciality" class="form-label">
							{{$t('text.speciality')}}:
							<font-awesome-icon :icon="['fas', 'spinner']" spin v-if="loadingSpecialities" class="ms-2" />
						</label>
						<select id="select-speciality" class="form-select" v-model="speciality_id" :disabled="loadingSpecialities">
							<option :value="speciality.id" v-for="speciality in specialities" :key="speciality.id">{{speciality.name}}</option>
						</select>
					</div>
					<div class="mb-3">
						<label for="select-qualification" class="form-label">
							{{$t('text.qualification')}}:
							<font-awesome-icon :icon="['fas', 'spinner']" spin v-if="loadingQualifications" class="ms-2" />
						</label>
						<select id="select-qualification" class="form-select" v-model="qualification_id" :disabled="!speciality_id || loadingQualifications">
							<option :value="qualification.id" v-for="qualification in qualifications" :key="qualification.id">{{qualification.name}}</option>
						</select>
					</div>
					<div>
						<label for="input-names" class="form-label">{{$t('text.names-via-enter')}}:</label>
						<textarea id="input-names" ref="names" rows="3" :placeholder="$t('placeholder.students-groups-names-via-enter')" class="form-control" v-model="names" required></textarea>
					</div>
				</div>
				<div class="alert alert-warning alert-dismissible fade show mt-2 mb-0" v-if="error">
					{{error}}
					<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
				</div>
			</div>
			<div class="modal-footer p-1">
				<button type="submit" class="btn btn-primary" :disabled="loading">{{$t('btn.add')}}</button>
				<button type="button" class="btn btn-outline-secondary" @click="$emit('cancel', close)">{{$t('btn.cancel')}}</button>
			</div>
		</form>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import autosize from 'autosize';

import LoadingSpinner from '@/components/LoadingSpinner';

export default {
	mixins: lib.mixins,
	inheritAttrs: false,
	//emits: ['confirm', 'cancel']
	data: () => ({
		specialities: [],
		qualifications: [],
		
		speciality_id: null,
		qualification_id: null,
		names: '',
		lang: 'ru',
		
		error: '',
		loading: false,
		loadingSpecialities: false,
		loadingQualifications: false,
	}),
	watch: {
		async lang(val, oldVal){
			this.speciality_id = null;
			this.qualification_id = null;
			await this.loadSpecialities();
		},
		async speciality_id(val, oldVal){
			this.qualification_id = null;
			await this.loadQualifications();
		},
	},
	methods: {
		// получение списка специальностей
		async loadSpecialities(){
			this.loadingSpecialities = true;
			this.error = '';
			let ret = await this.appModel.doGetSpecialitiesByLang(this.lang);
			if(ret.success){
				ret.list.unshift({
					id: null,
					name: 'Не указано',
					lang: this.lang,
				});
				this.specialities = ret.list;
			} else {
				this.error = ret.message;
			}
			this.loadingSpecialities = false;
		},
		
		// получение списка квалификаций
		async loadQualifications(){
			if(this.speciality_id){
				this.loadingQualifications = true;
				this.error = '';
				let ret = await this.appModel.doGetQualifications(this.speciality_id);
				if(ret.success){
					this.qualifications = ret.list;
				} else {
					this.error = ret.message;
				}
				this.loadingQualifications = false;
			}
		},
		
		async onAdd(close){
			this.loading = true;
			this.error = '';
			
			const names = this.names.trim().split('\n');
			if(names.length > 0){
				for(const name of names){
					if(name.trim()){
						await this.appModel.doAddStudentsGroup({
							group_lang: this.lang,
							speciality_id: this.speciality_id,
							qualification_id: this.qualification_id,
							name: name.trim(),
						});
					}
				}
				this.$emit('add', close);
			} else {
				this.$emit('cancel', close);
			}
			this.loading = false;
		},
	},
	async mounted(){
		await this.loadSpecialities();
		
		setTimeout(() => {
			autosize(this.$refs.names);
			this.$refs.names.focus();
		}, 300);
	},
	components: {
		LoadingSpinner,
	},
}
</script>